// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateEpmMasterRoleTypeMutationVariables = Types.Exact<{
  input: Types.UpdateEpmMasterRoleTypeInput;
}>;

export type UpdateEpmMasterRoleTypeMutation = { __typename?: 'Mutation' } & {
  updateEpmMasterRoleType: { __typename?: 'EpmMasterRoleTypeOutput' } & Pick<Types.EpmMasterRoleTypeOutput, 'id'>;
};

export const UpdateEpmMasterRoleTypeDocument = /*#__PURE__*/ gql`
    mutation updateEpmMasterRoleType($input: UpdateEpmMasterRoleTypeInput!) {
  updateEpmMasterRoleType(input: $input) {
    id
  }
}
    `;
export type UpdateEpmMasterRoleTypeMutationFn = Apollo.MutationFunction<
  UpdateEpmMasterRoleTypeMutation,
  UpdateEpmMasterRoleTypeMutationVariables
>;

/**
 * __useUpdateEpmMasterRoleTypeMutation__
 *
 * To run a mutation, you first call `useUpdateEpmMasterRoleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpmMasterRoleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpmMasterRoleTypeMutation, { data, loading, error }] = useUpdateEpmMasterRoleTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEpmMasterRoleTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEpmMasterRoleTypeMutation, UpdateEpmMasterRoleTypeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEpmMasterRoleTypeMutation, UpdateEpmMasterRoleTypeMutationVariables>(
    UpdateEpmMasterRoleTypeDocument,
    options,
  );
}
export type UpdateEpmMasterRoleTypeMutationHookResult = ReturnType<typeof useUpdateEpmMasterRoleTypeMutation>;
export type UpdateEpmMasterRoleTypeMutationOptions = Apollo.BaseMutationOptions<
  UpdateEpmMasterRoleTypeMutation,
  UpdateEpmMasterRoleTypeMutationVariables
>;
